const MIND_YETI_ROUTES = {
  BASE_URL: '/product/mind-yeti',
  RESOURCES: {
    DEFAULT: '/',
    PLAYLIST: '/playlists',
  },
}

const HIGH_SCHOOL_BASE_PATH = '/product/high-school'
const ELEMENTARY_BASE_PATH = '/product/elementary'
const MIDDLE_SCHOOL_BASE_PATH = '/product/middle-school'

const STATIC_ROUTE_SUFFIXES = [
  'program-supports',
  'program-supports-k5',
  'program-supports-el',
  'resources',
  'principal-toolkit',
  'trainings',
  'families',
  'staff-training',
  'program-training',
  'advisory-activities',
  'activities',
  'learning-resources',
  // the /admin route below is temporary and meant to sunset /sel-for-adults/leader-hub.
  // angie (or product) will let us know when they make a final decision on whether it will
  // supersede /leader-hub or be a new route entirely
  'admin',
  'leader-hub',
  'engage-families',
  'accessibility',
  'grades-k-1',
  'grades-2-3',
  'grades-4-5',
]

const ABSOLUTE_STATIC_ROUTES = [
  '/product/k5-kit/teach',
  '/product/bpu-kit/teach',
  '/product/cpu-kit/teach',
  '/product/el-kit/teach',
  '/product/ms-kit/ms-teach',
  `${MIND_YETI_ROUTES.BASE_URL}${MIND_YETI_ROUTES.RESOURCES.PLAYLIST}`,
  `${HIGH_SCHOOL_BASE_PATH}/training`,
  `${HIGH_SCHOOL_BASE_PATH}/pathways`,
]

const PAGES_V2_STATIC_ROUTES_ELEMENTARY = [
  `${ELEMENTARY_BASE_PATH}/activities`,
  `${ELEMENTARY_BASE_PATH}/intervention-resources`,
  `${ELEMENTARY_BASE_PATH}/trainings`,
  `${ELEMENTARY_BASE_PATH}/program-supports`,
  `${ELEMENTARY_BASE_PATH}/engage-families`,
  `${ELEMENTARY_BASE_PATH}/tier-2-3-resources`,
]

const PAGES_V2_STATIC_ROUTES_HIGH_SCHOOL = [
  `${HIGH_SCHOOL_BASE_PATH}/program-supports`,
  `${HIGH_SCHOOL_BASE_PATH}/training`,
  `${HIGH_SCHOOL_BASE_PATH}/pathways`,
  `${HIGH_SCHOOL_BASE_PATH}/extension-activities`,
]

const PAGES_V2_STATIC_ROUTES_MIDDLE_SCHOOL = [
  `${MIDDLE_SCHOOL_BASE_PATH}/advisory-activities`,
  `${MIDDLE_SCHOOL_BASE_PATH}/trainings`,
  `${MIDDLE_SCHOOL_BASE_PATH}/program-supports`,
  `${MIDDLE_SCHOOL_BASE_PATH}/engage-families`,
  `${MIDDLE_SCHOOL_BASE_PATH}/intervention-resources`,
  `${MIDDLE_SCHOOL_BASE_PATH}/tier-2-3-resources`,
]

export function getStaticRoutes(path) {
  return [
    ...STATIC_ROUTE_SUFFIXES.map(suffix => `${path}/${suffix}`),
    ...ABSOLUTE_STATIC_ROUTES,
  ]
}

export const PAGES_V2_STATIC_ROUTES = {
  elementary: PAGES_V2_STATIC_ROUTES_ELEMENTARY,
  highSchool: PAGES_V2_STATIC_ROUTES_HIGH_SCHOOL,
  middleSchool: PAGES_V2_STATIC_ROUTES_MIDDLE_SCHOOL,
}
